import { combineReducers } from 'redux'
import cards from './cards'
import print_requests from './print_requests'
import memory from './memory'

const rootReducer = combineReducers({
  cards,
  memory,
  print_requests
})

export default rootReducer
